import React, { useState, useMemo } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { FluentButton } from "../../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../../assets/fluent-ui-icon";
import { Avatar } from "@fluentui/react-components";
import { MeBadge } from "../../../dashboard-util/dashboard-utils";
import PropTypes from "prop-types";
import {
  renderTooltipHeader,
  createColumnMenu,
} from "../../../dashboard-util/dashboard-telerik-helper/dashboard-telerik-helper";

const EnergyBankerSummaryGrid = ({ summaryItem = {}, showDetails, onToggle }) => {
  const [summaryState, setSummaryState] = useState({ sort: [], filter: null });
  const gridData = useMemo(() => {
  if (!summaryItem?.User) return [];
  return [
    {
      ...summaryItem,
      UserName: summaryItem.User.Name,
    },
  ];
}, [summaryItem]);

  const isAccordionDisabled = true; //Logic for accordion is developed- but disabling it as per product's request
  const columnMenu = createColumnMenu(gridData);
  
  if (!summaryItem?.User) {
    return null;
  }
  
  return (
    <div className="summary-grid-wrapper">
      <Grid
        data={gridData}
        sort={summaryState.sort}
        filter={summaryState.filter}
        onSortChange={(e) => setSummaryState({ ...summaryState, sort: e.sort })}
        onFilterChange={(e) =>
          setSummaryState({ ...summaryState, filter: e.filter })
        }
        className="energy-banker-time-log-summary-grid"
        resizable={true}
      >
        <Column
          field="UserName"
          title={renderTooltipHeader("Name")}
          columnMenu={columnMenu}
          cell={(props) => {
            return (
              <td className="summary-cell k-table-td avatar-cell">
                <div className="avatar-content">
                  <Avatar name={summaryItem.User.Name} color="brand" size={32} />
                  <span>{summaryItem.User.Name}</span>
                  <MeBadge />
                </div>
              </td>
            );
          }}
        />
        <Column
          field="TotalHoursLastWeek"
          title={renderTooltipHeader("Total Wk Hrs Spent Last Week")}
          columnMenu={columnMenu}
          cell={(props) => (
            <td className="summary-cell k-table-td">
              {props.dataItem.TotalHoursLastWeek ?? "—"}
            </td>
          )}
        />
        <Column
          field="TotalWeekendHoursLastWeek"
          title={renderTooltipHeader("Total Wknd Hrs Spent Last Week")}
          columnMenu={columnMenu}
          cell={(props) => (
            <td className="summary-cell k-table-td">
              {props.dataItem.TotalWeekendHoursLastWeek ?? "—"}
            </td>
          )}
        />
        <Column
          field="TotalHoursNextWeek"
          title={renderTooltipHeader("Total Current Est. of Hrs (Nxt 7 Days)")}
          columnMenu={columnMenu}
          cell={(props) => (
            <td className="summary-cell k-table-td">
              {props.dataItem.TotalHoursNextWeek ?? "—"}
            </td>
          )}
        />
        <Column
          field=""
          title=""
          width="50px"
          cell={(props) => {
            return (
              <td className="summary-cell k-table-td">
                <FluentButton
                  className="accordion-toggle-button"
                  disabled={isAccordionDisabled}
                  icon={
                    <FluentUiIcon
                      name={showDetails ? "ChevronUpRegular" : "ChevronDownRegular"}
                      size={16}
                      color={isAccordionDisabled ? "A0A0A0" : "#0F6CBD"}
                      disabled={isAccordionDisabled}
                    />
                  }
                  appearance="transparent"
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggle();
                  }}
                />
              </td>
            );
          }}
        />
      </Grid>
    </div>
  );
};

export default EnergyBankerSummaryGrid;

EnergyBankerSummaryGrid.propTypes = {
  summaryItem: PropTypes.shape({
    User: PropTypes.shape({
      Name: PropTypes.string.isRequired,
    }).isRequired,
    TotalHoursLastWeek: PropTypes.number,
    TotalWeekendHoursLastWeek: PropTypes.number,
    TotalHoursNextWeek: PropTypes.number,
  }).isRequired,
  showDetails: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};